// =====================================================================
// Variáveis ({{chave}}) que cada tipo de mensagem do pós-venda aceita.
// Fonte única: os editores da tela oferecem estes chips e os textos
// sugeridos (textosSugeridos.ts) são testados contra estas listas.
// =====================================================================

export type Variavel = { chave: string; rotulo: string };

/** Variáveis genéricas (valem para qualquer mensagem com cliente + veículo). */
export const VARIAVEIS_BASICAS: Variavel[] = [
  { chave: 'cliente', rotulo: 'Nome do cliente' },
  { chave: 'veiculo', rotulo: 'Veículo' },
  { chave: 'placa', rotulo: 'Placa' },
  { chave: 'link', rotulo: 'Link' },
];

/**
 * Variáveis da ordem de serviço — só fazem sentido em mensagens ligadas a
 * uma OS (criação, mudança de status, manutenção e avaliação).
 */
export const VARIAVEIS_OS: Variavel[] = [
  { chave: 'numero', rotulo: 'Nº da OS' },
  { chave: 'total', rotulo: 'Total' },
  { chave: 'servicos', rotulo: 'Serviços feitos' },
  { chave: 'pecas', rotulo: 'Peças usadas' },
  { chave: 'itens', rotulo: 'Lista de itens' },
  { chave: 'data', rotulo: 'Data da OS' },
  { chave: 'km', rotulo: 'KM' },
  { chave: 'responsavel', rotulo: 'Responsável' },
  { chave: 'acompanhamento', rotulo: 'Link de acompanhamento' },
  { chave: 'avaliacao', rotulo: 'Link do formulário de avaliação' },
];

/** Aniversário/ausência não têm OS associada: só cliente e link. */
export const VARIAVEIS_CLIENTE: Variavel[] = [
  { chave: 'cliente', rotulo: 'Nome do cliente' },
  { chave: 'link', rotulo: 'Link' },
];

/** Mensagens ligadas a uma OS (criação, status, manutenção, avaliação). */
export const VARIAVEIS_COM_OS: Variavel[] = [...VARIAVEIS_BASICAS, ...VARIAVEIS_OS];

/** Campanha manual: vai para clientes, sem OS — cliente, veículo e link. */
export const VARIAVEIS_CAMPANHA: Variavel[] = VARIAVEIS_BASICAS;

/** Envio manual da OS pelo WhatsApp (modal da tela da ordem de serviço). */
export const VARIAVEIS_ENVIO_OS: Variavel[] = [
  { chave: 'cliente', rotulo: 'Cliente' },
  { chave: 'numero', rotulo: 'Nº da OS' },
  { chave: 'placa', rotulo: 'Placa' },
  { chave: 'servicos', rotulo: 'Serviços' },
  { chave: 'pecas', rotulo: 'Peças' },
  { chave: 'itens', rotulo: 'Lista de itens' },
  { chave: 'total', rotulo: 'Total' },
  { chave: 'data', rotulo: 'Data' },
  { chave: 'responsavel', rotulo: 'Responsável' },
  { chave: 'acompanhamento', rotulo: 'Link de acompanhamento' },
];
